import React from "react";

function IntroContent() {
    return (
        <div className="intro__content">
            <span>Learn to code by <br />watching others</span>
            <p>See how experienced developers solve problems in real-time. Watching scripted tutorials is great, but understanding how developers think is invaluable.</p>
        </div>
    )
}

export default IntroContent;